import { createFileRoute } from '@tanstack/react-router';

import { IdeasBoard } from '../../features/personal/IdeasBoard';

/** `/personal/ideas` = صندوق الأفكار (خطة القسم الشخصي ش2). */
export const Route = createFileRoute('/personal/ideas')({ component: IdeasBoard });
